import { render, staticRenderFns } from "./PrintOrderProduct.vue?vue&type=template&id=643b6408&scoped=true"
import script from "./PrintOrderProduct.vue?vue&type=script&lang=js"
export * from "./PrintOrderProduct.vue?vue&type=script&lang=js"
import style0 from "./PrintOrderProduct.vue?vue&type=style&index=0&id=643b6408&prod&lang=scss&scoped=true"
import style1 from "./PrintOrderProduct.vue?vue&type=style&index=1&id=643b6408&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b6408",
  null
  
)

export default component.exports